"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HotelWithOfferDetails = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _classnames6 = _interopRequireDefault(require("classnames"));
var _reactRouter = require("react-router");
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _helpers = require("@otpusk/apisearch-toolbox/dist/offers/helpers");
var _selectors = require("@otpusk/apisearch-toolbox/dist/services/selectors");
var _reactDeviceDetect = require("react-device-detect");
var _handlers = require("../../../../helpers/handlers");
var _fn = require("../../../../helpers/fn");
var _book = require("../../../routes/book");
var _config = require("../../../../services/config");
var _Button = _interopRequireDefault(require("../../../ui/Button"));
var _Tooltip = _interopRequireWildcard(require("../../../ui/Tooltip"));
var _GalleryModal = require("../GalleryModal");
var _Checkbox = _interopRequireDefault(require("../../../ui/Checkbox"));
var _hocs = require("../../hocs");
var _Services = _interopRequireDefault(require("./components/Services"));
var _AddToCollectionButton = _interopRequireDefault(require("./components/AddToCollectionButton"));
var _GeoMarker = _interopRequireDefault(require("./components/GeoMarker"));
var _Rating = _interopRequireDefault(require("./components/Rating"));
var _OpenOfferButton = require("./components/OpenOfferButton");
var _look = _interopRequireDefault(require("./img/look.svg"));
var _combined = _interopRequireDefault(require("./img/combined.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ResultHotelPure = function ResultHotelPure(_ref) {
  var averageRating = _ref.averageRating,
    city = _ref.city,
    commentJSX = _ref.commentJSX,
    compact = _ref.compact,
    country = _ref.country,
    district = _ref.district,
    className = _ref.className,
    currency = _ref.currency,
    hotelID = _ref.hotelID,
    _ref$isCrossTour = _ref.isCrossTour,
    isCrossTour = _ref$isCrossTour === void 0 ? false : _ref$isCrossTour,
    isMobile = _ref.isMobile,
    isEnabledCollectionsFeature = _ref.isEnabledCollectionsFeature,
    isShowOpenOfferButton = _ref.isShowOpenOfferButton,
    name = _ref.name,
    mbOfferKey = _ref.offerID,
    photo = _ref.photo,
    secondaryStars = _ref.secondaryStars,
    services = _ref.services,
    selected = _ref.selected,
    sourceRatings = _ref.sourceRatings,
    stars = _ref.stars,
    _ref$stylesMap = _ref.stylesMap,
    stylesMap = _ref$stylesMap === void 0 ? _styles.default : _ref$stylesMap,
    watermark = _ref.watermark,
    withOfferDetails = _ref.withOfferDetails,
    onOpenOfferDetailsModal = _ref.onOpenOfferDetailsModal,
    onOpenMap = _ref.onOpenMap,
    onSelect = _ref.onSelect;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULTS'),
    t = _useTranslation.t;
  var servicesIcons = (0, _reactRedux.useSelector)(function (store) {
    return (0, _selectors.getServicesIconsForHotel)(store, {
      countryID: country.id
    });
  });
  var labels = (0, _reactRedux.useSelector)(_selectors.getLabels);
  var servicesWithLabels = (0, _react.useMemo)(function () {
    return R.call(R.pipe(R.filter(function (service) {
      return R.includes(service, services);
    }), R.map(function (service) {
      return {
        service: service,
        label: labels[service]
      };
    })), servicesIcons);
  }, [labels, services, servicesIcons]);
  var hotelPhoto = (0, _react.useMemo)(function () {
    return (0, _dictionary.getImageUrl)(photo, 'small', watermark);
  }, [photo, watermark]);
  var combinedStars = (0, _react.useMemo)(function () {
    return (0, _fn.combineHotelStars)(stars, secondaryStars);
  }, [secondaryStars, stars]);
  var _useMemo = (0, _react.useMemo)(function () {
      var page = null;
      var isHotel = false;
      if (mbOfferKey) {
        var offerID = (0, _helpers.isOfferKey)(mbOfferKey) ? (0, _helpers.extractDataFromOfferKey)(mbOfferKey).id : mbOfferKey;
        page = (0, _reactRouter.generatePath)(_book.book.offer, {
          hotelID: hotelID,
          offerID: offerID
        });
      } else if (hotelID) {
        page = (0, _reactRouter.generatePath)(_book.book.hotel, {
          hotelID: hotelID
        });
        isHotel = true;
      }
      if (page && currency) {
        page = "".concat(page, "?currency=").concat(currency);
      }
      return {
        hotelNameLink: page,
        isHotelLink: isHotel
      };
    }, [currency, hotelID, mbOfferKey]),
    hotelNameLink = _useMemo.hotelNameLink,
    isHotelLink = _useMemo.isHotelLink;
  var dispatch = (0, _reactRedux.useDispatch)();
  var handleOpenGalleryModal = function handleOpenGalleryModal() {
    return dispatch((0, _GalleryModal.showGalleryModal)(hotelID));
  };
  var hotelTitleJSX = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: "".concat(name, " ").concat(combinedStars),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames6.default)(_styles.default.hotelName, _defineProperty(_defineProperty({}, _styles.default.longStars, combinedStars.length === 5), _styles.default.isCrossTour, isCrossTour), stylesMap.hotelName)
  }, name, "\xA0")), /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.hotelStar
  }, combinedStars), isCrossTour && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0+", /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('COMBINED_TOUR'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.combinedTours,
    dangerouslySetInnerHTML: {
      __html: _combined.default
    }
  }))));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles.default.resultHotel, className, _defineProperty(_defineProperty(_defineProperty({}, _styles.default.isMobile, isMobile), _styles.default.withDetails, withOfferDetails), _styles.default.compact, compact))
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _classnames6.default)(_styles.default.resultHotelImgButton, stylesMap.resultHotelImgButton),
    icon: _look.default,
    iconClassName: _styles.default.lookIcon,
    onClick: (0, _handlers.handleWith)(_handlers.prevent, handleOpenGalleryModal)
  }, onSelect && /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: selected,
    onClick: _handlers.stop,
    className: _styles.default.checkbox,
    onChange: onSelect
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles.default.resultHotelImg, stylesMap.resultHotelImg),
    style: {
      backgroundImage: "url(\"".concat(hotelPhoto, "\")")
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles.default.resultHotelBody, stylesMap.resultHotelBody, _defineProperty({}, _styles.default.hasServices, !R.isEmpty(servicesWithLabels)))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles.default.resultHotelInfo, stylesMap.resultHotelInfo)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles.default.nameWrapper, stylesMap.nameWrapper)
  }, hotelNameLink ? /*#__PURE__*/_react.default.createElement("a", {
    rel: "noreferrer",
    "aria-label": name,
    className: (0, _classnames6.default)(_styles.default.resultHotelName, stylesMap.resultHotelName),
    href: hotelNameLink,
    target: !(0, _config.isEnabledMT2StrategyForOpeningOfferDetailModal)() || isHotelLink ? '_blank' : undefined,
    onClick: withOfferDetails && (0, _config.isEnabledMT2StrategyForOpeningOfferDetailModal)() ? onOpenOfferDetailsModal : undefined
  }, hotelTitleJSX) : hotelTitleJSX, isShowOpenOfferButton && /*#__PURE__*/_react.default.createElement(_OpenOfferButton.OpenOfferButton, {
    className: _styles.default.openOfferButton,
    page: hotelNameLink
  })), !R.isEmpty(sourceRatings) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles.default.ratingContainer, stylesMap.ratingContainer, _defineProperty({}, _styles.default.middleRatings, !commentJSX))
  }, /*#__PURE__*/_react.default.createElement(_Rating.default, {
    averageRating: averageRating,
    compact: compact,
    isMobile: isMobile,
    sourceRatings: sourceRatings,
    labelClassName: stylesMap.ratingLabel
  })), isEnabledCollectionsFeature && /*#__PURE__*/_react.default.createElement(_AddToCollectionButton.default, {
    countryID: country.id,
    hotelID: hotelID
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultHotelFooter
  }, /*#__PURE__*/_react.default.createElement(_GeoMarker.default, {
    compact: compact,
    isMobile: isMobile,
    className: stylesMap.geoMarker,
    onClick: onOpenMap
  }, city.name, district && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, district.name && ', ', district.name)), !R.isEmpty(servicesWithLabels) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles.default.servicesContainer, stylesMap.servicesContainer, _defineProperty({}, _styles.default.bottomServices, !commentJSX))
  }, /*#__PURE__*/_react.default.createElement(_Services.default, {
    className: stylesMap.services,
    compact: compact,
    services: servicesWithLabels
  })), _reactDeviceDetect.isDesktop && compact && commentJSX), (_reactDeviceDetect.isDesktop && !compact || isMobile && compact) && commentJSX)), (isMobile || _reactDeviceDetect.isMobile) && !compact && commentJSX && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.commentContainer
  }, commentJSX));
};
ResultHotelPure.propTypes = {
  city: _propTypes.default.shape({
    name: _propTypes.default.string
  }).isRequired,
  country: _propTypes.default.shape({
    id: _propTypes.default.number.isRequired
  }).isRequired,
  name: _propTypes.default.string.isRequired,
  photo: _propTypes.default.string.isRequired,
  services: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])).isRequired,
  averageRating: _propTypes.default.number,
  className: _propTypes.default.string,
  compact: _propTypes.default.bool,
  currency: _propTypes.default.string,
  district: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired
  }),
  hotelID: _propTypes.default.number,
  isEnabledCollectionsFeature: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  isCrossTour: _propTypes.default.bool,
  isShowOpenOfferButton: _propTypes.default.bool,
  offerID: _propTypes.default.string,
  secondaryStars: _propTypes.default.number,
  sourceRatings: _propTypes.default.array,
  selected: _propTypes.default.bool,
  withOfferDetails: _propTypes.default.bool,
  onOpenDetailsModal: _propTypes.default.func,
  onOpenMap: _propTypes.default.func,
  onSelect: _propTypes.default.func
};
ResultHotelPure.defaultProps = {
  withOfferDetails: false,
  isEnabledCollectionsFeature: false
};
var ResultHotel = (0, _react.memo)(ResultHotelPure);
var _default = exports.default = ResultHotel;
var HotelWithOfferDetails = exports.HotelWithOfferDetails = (0, _hocs.withOpenOfferDetailsHandler)(ResultHotel);
HotelWithOfferDetails.defaultProps = {
  withOfferDetails: true
};